import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=013ffd5c&scoped=true"
import script from "./homeFooter.vue?vue&type=script&lang=js"
export * from "./homeFooter.vue?vue&type=script&lang=js"
import style0 from "./homeFooter.vue?vue&type=style&index=0&id=013ffd5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ffd5c",
  null
  
)

export default component.exports